const nutritionPageTranslations = {
  intro: {
    title: "استمتع بوجباتك اللذيذة",
    description:
      "يمكنك الاختيار بحرية من بين مجموعة واسعة من الوصفات المختلفة، جميعها مصممة لتناسب احتياجاتك من العناصر الغذائية.",
  },
  mealOptions: {
    title: "اختر أحد الخيارات.",
  },
  mealsSlots: {
    title: "حدد وقت الوجبة.",
  },
  ingredientsPopUp: {
    title: "المكونات",
    close: "إغلاق",
  },
};

export default nutritionPageTranslations;
